import React from "react";
import Layout from "../components/Layout";
import SEO from "../components/SEO";

const SECTIONS = [
  {
    h: "01 — Website Use",
    p: "Your access to and use of the Elliott International Development LLC ('EID', 'we', 'us', 'our') website is conditioned upon your acceptance of and compliance with these Terms & Conditions. By accessing or using the site, you agree to be bound by these terms. If you disagree with any part of these terms, you should not access the site.",
  },
  {
    h: "02 — Informational Purposes Only",
    p: "All content on this website — including renderings, projections, project descriptions, statistics, timelines, amenities, and capital structures — is provided strictly for informational and illustrative purposes. Renderings are conceptual and subject to change. Specifications, dimensions, features, finishes, and amenities are subject to modification, substitution, or removal without notice.",
  },
  {
    h: "03 — No Investment, Legal, Financial, or Development Guarantee",
    p: "Nothing on this website constitutes an offer to sell or a solicitation of an offer to buy any security, real-estate interest, or investment. No representation or warranty is made that any development, investment opportunity, or projected outcome will be realized. Past performance is not indicative of future results. Real-estate development is subject to numerous risks — including market conditions, financing, regulatory approvals, construction, and macroeconomic factors. You should consult qualified legal, financial, and investment professionals before making any decision.",
  },
  {
    h: "04 — Intellectual Property",
    p: "All content on this website — including text, graphics, renderings, photographs, logos, trademarks, design elements, and source code — is the exclusive property of Elliott International Development LLC or its licensors, and is protected by United States and international intellectual-property law. You may not reproduce, distribute, modify, transmit, or use any portion of the site for commercial purposes without our prior written consent.",
  },
  {
    h: "05 — Limitation of Liability",
    p: "To the maximum extent permitted by law, EID and its officers, directors, employees, affiliates, and agents shall not be liable for any direct, indirect, incidental, consequential, special, or punitive damages arising out of or relating to your use of, or inability to use, this website or any content therein — even if advised of the possibility of such damages. Your sole remedy for dissatisfaction with the site is to discontinue use.",
  },
  {
    h: "06 — Third-Party Links",
    p: "This website may contain links to third-party websites that are not owned or controlled by EID. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites. You acknowledge and agree that EID shall not be responsible or liable for any damage or loss caused by use of any third-party content.",
  },
  {
    h: "07 — Updates to These Terms",
    p: "We reserve the right, at our sole discretion, to modify or replace these Terms at any time. Material changes will be reflected by an updated 'Last Updated' date below. Your continued use of the website following the posting of revised terms constitutes acceptance of those changes.",
  },
  {
    h: "08 — Governing Law",
    p: "These Terms shall be governed and construed in accordance with the laws of the State of Florida, without regard to its conflict-of-law provisions. Any dispute arising hereunder shall be subject to the exclusive jurisdiction of the state and federal courts located in Hillsborough County, Florida.",
  },
  {
    h: "09 — Contact",
    p: "Questions regarding these Terms may be directed to contact@elliottdev.com or by mail to: Elliott International Development LLC, 410 S Ware Blvd, Tampa, FL 33619.",
  },
];

export default function TermsPage() {
  return (
    <Layout>
      <SEO title="Terms & Conditions" description="Terms & Conditions governing use of the Elliott International Development website." path="/terms" />
      <section className="pt-40 pb-16 px-6 lg:px-12">
        <div className="max-w-[1200px] mx-auto">
          <div className="overline mb-6">— Legal</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[0.98] font-light tracking-tight">Terms & <em className="text-primary italic">Conditions</em></h1>
          <p className="mt-6 font-mono text-xs text-foreground/50">Last updated: May 22, 2026</p>
        </div>
      </section>

      <section className="px-6 lg:px-12 pb-32">
        <div className="max-w-[1000px] mx-auto divide-y divide-primary/10 border-t border-primary/10">
          {SECTIONS.map((s) => (
            <div key={s.h} data-testid={`terms-section-${s.h.slice(0, 2)}`} className="py-10">
              <div className="overline mb-4 text-primary">{s.h}</div>
              <p className="text-base md:text-lg text-foreground/80 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
